import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { Toaster } from '@/components/ui/sonner';
import ErrorBoundary from './components/ErrorBoundary';
import LandingPage from './components/LandingPage';
import ProfessorPage from './components/ProfessorPage';
import StudentPage from './components/StudentPage';
import JoinPage from './components/JoinPage';

function App() {
  return (
    <BrowserRouter>
      {/* App-wide catch-all so nothing can blank the screen. Each route also has
          its own boundary so a crash in one view stays contained to that view. */}
      <ErrorBoundary name="app">
        <Routes>
          <Route path="/" element={<ErrorBoundary name="landing"><LandingPage /></ErrorBoundary>} />
          <Route path="/professor" element={<ErrorBoundary name="professor"><ProfessorPage /></ErrorBoundary>} />
          <Route path="/student" element={<ErrorBoundary name="student-join"><JoinPage /></ErrorBoundary>} />
          <Route path="/student/:sessionId" element={<ErrorBoundary name="student"><StudentPage /></ErrorBoundary>} />
          <Route path="/join" element={<ErrorBoundary name="join"><JoinPage /></ErrorBoundary>} />
        </Routes>
      </ErrorBoundary>
      <Toaster />
      <Analytics />
    </BrowserRouter>
  );
}

export default App;
